'use strict';

/*
- reduce refocusing/rezooming (happens because we reset content/dispatch mapLoaded)
  - [x] autosaver to check for merge conflicts
    -- offer a dialog to merge before forcing it
      - pause autosave while the dialog is running
    - [x] if no conflicts, use "save" instead of 'overwrite'
*/

module.exports = function GoogleDriveAutosaver(config, pageController, navigatorShim, unsavedChangesModel) {
	let manualSaveRunning, autosaveRunning, hasUnsavedChanges, lastKnownContext, intervalId;
	if (!config || !pageController || !navigatorShim || !unsavedChangesModel) {
		throw new Error('invalid-args');
	}
	const autosave = function () {
		if (!manualSaveRunning && !autosaveRunning && lastKnownContext && lastKnownContext.isAutosaved && hasUnsavedChanges) {
			autosaveRunning = true;
			return pageController.autosave()
			.catch(() => false)
			.then(() => autosaveRunning = false);
		}
	};
	unsavedChangesModel.addEventListener('unsavedChanges', () => hasUnsavedChanges = true);
	unsavedChangesModel.addEventListener('noUnsavedChanges', () => {
		hasUnsavedChanges = false;
	});
	pageController.addEventListener('fileLoaded', function (fileId, title, context) {
		if (context) {
			lastKnownContext = context;
		}
		if (!intervalId) {
			intervalId = navigatorShim.setInterval(autosave, config.driveAutosavePeriodSeconds * 1000);
		}
	});
	pageController.addEventListener('savingFile autosaveConfirmationRequired', () => manualSaveRunning = true);
	pageController.addEventListener('saveConfirmationRequired error', () => {
		manualSaveRunning = false;
	});
	pageController.addEventListener('saveFileSuccess fileMerged filePropertiesChanged', function (context) {
		if (context) {
			lastKnownContext = context;
		}
		manualSaveRunning = false;
	});
};
